import styled from 'styled-components/macro';

const ZoomImage = styled.img`
  display: block;
  height: 100%;
  width: auto;
  max-height: 80vh;
  max-width: 80vw;
  margin-top: 8px;
`;

export default ZoomImage;
